// extracted by mini-css-extract-plugin
module.exports = {"image":"section-greenpath-module--image--2qLTq"};